var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83482 7.875C2.29482 9.002 2.48482 10.321 2.86482 12.958L3.14282 14.895C3.62982 18.283 3.87382 19.976 5.04882 20.988C6.22382 22 7.94682 22 11.3938 22H13.6058C17.0528 22 18.7758 22 19.9508 20.988C21.1258 19.976 21.3698 18.283 21.8568 14.895L22.1358 12.958C22.5158 10.321 22.7058 9.002 22.1648 7.875C21.6248 6.748 20.4738 6.062 18.1728 4.692L16.7878 3.867C14.6998 2.622 13.6538 2 12.4998 2C11.3458 2 10.3008 2.622 8.21182 3.867L6.82682 4.692C4.52682 6.062 3.37582 6.748 2.83482 7.875ZM12.4998 18.75C12.3009 18.75 12.1101 18.671 11.9695 18.5303C11.8288 18.3897 11.7498 18.1989 11.7498 18V15C11.7498 14.8011 11.8288 14.6103 11.9695 14.4697C12.1101 14.329 12.3009 14.25 12.4998 14.25C12.6987 14.25 12.8895 14.329 13.0302 14.4697C13.1708 14.6103 13.2498 14.8011 13.2498 15V18C13.2498 18.1989 13.1708 18.3897 13.0302 18.5303C12.8895 18.671 12.6987 18.75 12.4998 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.7bf8deab945dd9a815a9c34adaf741ed.svg";
export { ForwardRef as ReactComponent };